// extracted by css-extract-rspack-plugin
export default {"root":"IntegrationHistoryDateCell_root__sRqPz"};